export enum SocketStateEnum {
  RECONNECTING = 'RECONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  CONNECT_ERROR = 'CONNECT_ERROR',
  CONNECTING = 'CONNECTING',
  INITIAL = 'INITIAL',
}
